export const formatCurrency = (
  amount: number | null,
  currency: string,
  minimumFractionDigits = 2,
  locale?: string
): string => {
  if (amount === null) return `${amount}`;

  const browserLocale =
    typeof window !== "undefined" ? window.navigator.language : "en-US"; // fallback to en-US if no locale is provided because "US$0.00" looks odd
  const usedLocale = locale || browserLocale;

  return new Intl.NumberFormat(usedLocale, {
    style: "currency",
    currency: currency.toUpperCase(),
    minimumFractionDigits: minimumFractionDigits,
  }).format(amount / 100);
};
